import { SVGProps } from 'react';

interface BatteryIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  level: number;
}

export const BatteryIcon = ({
  width = 16,
  height = 16,
  level,
  className = '',
  ...props
}: BatteryIconProps) => {
  const getColor = () => {
    if (level < 0.2) return '#ef4444';
    if (level < 0.5) return '#f59e0b';
    return '#10b981';
  };

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <rect
        x='2'
        y='7'
        width='18'
        height='10'
        rx='2'
        stroke={getColor()}
        strokeWidth='2'
        fill='none'
      />
      <rect
        x='4'
        y='9'
        width={14 * level}
        height='6'
        rx='1'
        fill={getColor()}
      />
      <rect x='20' y='10' width='2' height='4' fill='#6b7280' />
    </svg>
  );
};
